/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `POST /api/data-property-group`
 */
export interface ApiDataPropertyGroupPostRequest {
  /**
   * 场景id
   */
  sceneId: number;
  /**
   * 属性组名称
   */
  name: string;
  /**
   * 数据属性列表
   */
  dataPropertyIds: number[];
}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `POST /api/data-property-group`
 */
export type ApiDataPropertyGroupPostResponse = boolean;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `POST /api/data-property-group`
 */
type ApiDataPropertyGroupPostRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-property-group',
    'retdata',
    string,
    string,
    false
  >
>;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `POST /api/data-property-group`
 */
const apiDataPropertyGroupPostRequestConfig: ApiDataPropertyGroupPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-property-group',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataPropertyGroupPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `POST /api/data-property-group`
 */
export const apiDataPropertyGroupPost = /*#__PURE__*/ (
  requestData: ApiDataPropertyGroupPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDataPropertyGroupPostResponse>(
    prepare(apiDataPropertyGroupPostRequestConfig, requestData),
    ...args
  );
};

apiDataPropertyGroupPost.requestConfig = apiDataPropertyGroupPostRequestConfig;

/* prettier-ignore-end */
